// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1iplB","signatureButtonsRight":"ModalSign_signatureButtonsRight__3NotY"};